if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        const cardWrapper = this.closest(".product-grid-item__action-visibal-cart");

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {

            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (this.cartNotification) {
              // Keep the drawer's contents fresh so "View cart" always shows
              // up-to-date data, but don't pop it open on every add - the
              // sticky cart bar is the feedback for that now.
              this.cartNotification.renderContents(parsedState, false);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");

            if (typeof publish === "function") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                cartData: parsedState,
                variantId: parsedState.variant_id,
              });
            }

            if (cardWrapper) {
              this.showQuantityStepper(cardWrapper, parsedState.variant_id, parsedState.quantity || 1);
            }
          })
          .catch(() => {

          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      showQuantityStepper(cardWrapper, variantId, quantity) {
        const stepper = cardWrapper.querySelector(".product-grid-item__qty-stepper");
        if (!stepper) return;

        stepper.dataset.variantId = variantId;
        stepper.dataset.qty = quantity;
        stepper.querySelector(".product-grid-item__qty-value").textContent = quantity;

        this.hidden = true;
        stepper.hidden = false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}

// Product card quantity stepper: shown in place of the "Add to cart" button
// once an item has been added from a card. +/- updates the cart line via
// the AJAX Cart API (by variant id) and keeps the sticky cart bar / header
// count in sync via the same PUB_SUB_EVENTS.cartUpdate event.
(function () {
  if (window.__productCardStepperInit) return;
  window.__productCardStepperInit = true;

  function setStepperLoading(stepper, isLoading) {
    stepper
      .querySelectorAll("button")
      .forEach((btn) => (btn.disabled = isLoading));
    stepper.classList.toggle("loading", isLoading);
  }

  function changeCardQuantity(stepper, newQuantity) {
    const variantId = stepper.dataset.variantId;
    if (!variantId) return;

    setStepperLoading(stepper, true);

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body: JSON.stringify({ id: variantId, quantity: newQuantity }) },
    })
      .then((response) => response.json())
      .then((cartState) => {
        if (cartState.status) return;

        if (newQuantity <= 0) {
          const cardWrapper = stepper.closest(
            ".product-grid-item__action-visibal-cart"
          );
          const form = cardWrapper && cardWrapper.querySelector("product-form");
          stepper.hidden = true;
          if (form) form.hidden = false;
          stepper.dataset.qty = 0;
        } else {
          stepper.dataset.qty = newQuantity;
          stepper.querySelector(".product-grid-item__qty-value").textContent =
            newQuantity;
        }

        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-card-stepper",
            cartData: cartState,
            variantId: variantId,
          });
        }

        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification && cartNotification.getSectionsToRender) {
          fetch(
            `${window.location.pathname}?sections=${cartNotification
              .getSectionsToRender()
              .map((s) => s.id)
              .join(",")}`
          )
            .then((r) => r.json())
            .then((sections) => {
              cartNotification.getSectionsToRender().forEach((section) => {
                const el = document.getElementById(section.id);
                if (el && sections[section.id]) {
                  el.innerHTML = cartNotification.getSectionInnerHTML(
                    sections[section.id]
                  );
                }
              });
            })
            .catch(() => {});
        }
      })
      .catch(() => {})
      .finally(() => setStepperLoading(stepper, false));
  }

  document.addEventListener("click", function (evt) {
    const decreaseBtn = evt.target.closest(".product-grid-item__qty-decrease");
    const increaseBtn = evt.target.closest(".product-grid-item__qty-increase");
    if (!decreaseBtn && !increaseBtn) return;

    const stepper = evt.target.closest(".product-grid-item__qty-stepper");
    if (!stepper) return;

    const currentQty = parseInt(stepper.dataset.qty || "0", 10);
    const nextQty = decreaseBtn ? currentQty - 1 : currentQty + 1;
    changeCardQuantity(stepper, nextQty);
  });
})();